import React from 'react';
import { HashRouter } from 'react-router-dom';
import Expose from '../src/Expose/Expose';
import { withModalContext } from '../src/contexts/ModalContext';

function App() {
  return (
    <HashRouter>
      <Expose />
    </HashRouter>
  );
}

export default withModalContext(App);
